import React, { Fragment } from 'react'
import { IconGroupProps } from './types'
import resolveProps from '../../../utils/resolveProps'
const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  modifiers: [],
  state: []
}

function IconGroup(props: IconGroupProps) {
  const { inverse, icons } = props
  return (
    <div
      className={resolveProps(props, config, 'IconGroup')}
    >
      {icons?.map((icon, index) => {
        if (index + 1 === icons.length) {
          return (
            <i
              key={index}
              className={`${icon.name} mdn-Icon--${icon.size} ${icon.className || ''}`}
              aria-label={icon.ariaLabel}
            ></i>
          )
        }
        return (
          <React.Fragment key={index}>
            <i
              aria-label={icon.ariaLabel}
              className={`${icon.name} mdn-Icon--${icon.size} ${icon.className || ''}`}
            ></i>
            <span className="mdn-IconGroup-plus">+</span>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default IconGroup
